<div class="text-center">
    <div class="selectMonth"><b>Select Month</b></div>
    <div class="relative">
        <ng-select #monthSelect class="custom-ng-select" [items]="monthList" bindLabel="month_of_attendance"
            [multiple]="false" [closeOnSelect]="true" [clearable]="true" [loading]="monthLoading"
            [typeahead]="monthInput$" typeToSearchText="Employee Name" [virtualScroll]="true"
            [(ngModel)]="selectedMonth"></ng-select>
        <i class="fa fa-search"></i>
    </div>
</div>